import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "banner-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BannerItem = _resolveComponent("BannerItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _mergeProps({
      class: "banner-list-scroll",
      ref: "scroll"
    }, _ctx.bannerScroll(), {
      onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.touchStart(...args))),
      onTouchmove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.touchMove(...args))),
      onTouchend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.touchEnd(...args)))
    }), [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getBannerList(), (item) => {
        return (_openBlock(), _createBlock(_component_BannerItem, {
          class: "banner-list-item",
          key: item.id,
          imageUrl: item.imageUrl,
          id: item.id,
          onOnClick: _ctx.onClick
        }, null, 8, ["imageUrl", "id", "onOnClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 16)
  ]))
}